import { InfiniteData, MutationOptions } from "@tanstack/react-query";
import {
  useAuthInfiniteQuery,
  useAuthMutation,
  UseInfiniteQueryExtendedOptions,
} from "@rentablo/api";
import {
  BookingsApiListAndSearchAllBookingsRequest,
  CACHE_KEYS,
  listAndSearchAllBookings,
  PageableBookingList,
} from "@rentablo/api/apiv1";
import { deleteBooking } from "@api/v1/methods";

export const useDeleteBooking = (
  options: MutationOptions<unknown, AxiosApiError, unknown> = {}
) => useAuthMutation(deleteBooking, options);

export const useInfiniteListAndSearchAllBookings = (
  params?: BookingsApiListAndSearchAllBookingsRequest,
  options?: UseInfiniteQueryExtendedOptions<
    PageableBookingList,
    AxiosApiError,
    InfiniteData<PageableBookingList>
  >
) => {
  return useAuthInfiniteQuery(
    [CACHE_KEYS.LIST_AND_SEARCH_ALL_BOOKINGS, "infinite", params],
    ({ token, pageParam }) =>
      listAndSearchAllBookings(token, {
        ...params,
        page: (pageParam as number) || 1,
      }),
    options
  );
};
